import React, { useState } from "react";
import { Modal, Button, TwSelector as Selector, TwFileUpload as FileUpload, Link, Loader, Icon, Text } from "@ui-component-library";
import { ContentContainer } from "./utils/utils";
import { generateForestandProperty } from "../../../../../api/services/property";
import {ErrorModal} from "../../../../../modals";
import { usePropsDataStore } from "../../../store/PropsDataStore";
import { GrowingContainer } from "./utils/utils";

export const UploadForestandStep = ({ handleNext, arbonicsData, updateCo2Deal}) => {
    const setOneProp = usePropsDataStore((state) => state.setOneProp);

    const [fileError, setFileError] = useState('')
    const [successText, setSuccessText] = useState('')

    const [file, setFile] = useState([])
    const [isLoading,setIsLoading] = useState(false)
    const [errorModal,setErrorModal] = useState(false)
    const [isValid, setIsValid] = useState(null)

    const handleSubmit = async() => {
        setIsLoading(true)
        let propandFile = {...arbonicsData, "forestandFile":file[0].file}
       
        if (propandFile?.forestandFile && propandFile?.selectedProp){
            var formData = new FormData()
            formData.append('file', propandFile.forestandFile)
            formData.append('lmID', propandFile.selectedProp.ref)
            formData.append('designation_overwrite', propandFile.selectedProp.designation)
     

            const resp = await generateForestandProperty(formData)
            if (resp.ok){
                setOneProp(resp.data)
                let sbo = resp.data
                let co2FormData = new FormData()
                co2FormData.append('file', propandFile.forestandFile)
                co2FormData.append('stage', 'forestand')
                co2FormData.append('comments', 'Not sent, only finished step 2')
                const resp2 = await updateCo2Deal(co2FormData, false)
                handleNext({
                    data: {
                        sbo:sbo,
                        forestand_data_req: formData
                    },
                });
                setIsLoading(false)
            }
            else{
                setIsLoading(false)
                setErrorModal(true)
            }
        }
        else{
            setIsLoading(false)
            setErrorModal(true)
        }

        
    };

    const runValidation = async (uploadedFiles) => {
        const validated = await Promise.all(
        uploadedFiles.map(async (f) => {
            const valid = await validateFiles(f); 
            f.valid = valid
            return f;
        })
        );

        const allValid = validated.every((f) => f.valid);

        setFile(validated);
        setIsValid(validated.length === 0 ? undefined : allValid);

        return validated;
    };


    async function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => reject(reader.error);
            
            reader.readAsText(file);
        });
    }

    
    const validateFiles = async (data) => {
        if(data.file.name.split(".")[1].toLowerCase() == "pcskogz"){
            setFileError("Din fil är en pcskog fil, kontakta kolkrediter@treebula.se")
            const co2FormData = new FormData()
            co2FormData.append('file', data.file)
            co2FormData.append('comments', "User tried to upload .pcskogz")
            await updateCo2Deal(co2FormData, false)
            return false;
        }


        const fileText = await Promise.resolve(readFileAsync(data.file))
        if (fileText.includes("ForestandData")) {
            setSuccessText("Du har laddat upp en korrekt fil");
            setFileError("");
            return true;
        }
        setFileError("Detta verkar inte vara en forestand fil")
        return fileText.indexOf("ForestandData") != -1
    }

    if (isLoading) {
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", width: "100%", flexDirection: "column", gap: "8px", }} >
            <Text variant="text-base/leading-none/normal">Bearbetar din fil... </Text>
            <Loader />
          </div>
        );
      }
    return (
        <>
            <Modal.Content>
                <ContentContainer>
                    <GrowingContainer>
                        <>
                            <Text variant="text-base/leading-none/semibold">Vald fastighet</Text>
                            <Selector>
                                {[
                                    {
                                        label: arbonicsData.selectedProp.designation,
                                        value: arbonicsData.selectedProp.ref 
                                    },
                                ].map((option) => (<Selector.Option
                                    onClick={() => { }}
                                    {...option}
                                    key={option.value}
                                    isSelected={ option.value} />))
                                }
                            </Selector>
                            <Text variant="text-base/leading-none/semibold">Ladda upp forestand fil</Text>
                            <Text variant="text-sm/leading-normal/normal">Du behöver ladda upp en forestand fil för att vi ska kunna analysera din fastighetspotential. Forestand filen får bara innehålla en fastighet för att analysen skall bli rätt.</Text>
                            <FileUpload
                                accept=".xml, .pcskogz"
                                buttonText="Ladda upp forestand"  
                                errorText={fileError}
                                successText={successText}
                                label="Filer som stöds: XML"
                                onChange={runValidation} 
                                isValid={isValid}
                                value ={file}
                                /> 
                            <Text variant="text-base/leading-none/semibold">Vad är en forestand fil?</Text>
                            <Text variant="text-sm/leading-normal/normal">Vi har skapat en informationssida för hur du bäst får tag på din forestand fil.<Link href="/u/forestand/" underline target="_blank" className="text-green"> Klicka här för att läsa mer.</Link></Text>
                        </>
                    </GrowingContainer>
                </ContentContainer>
            </Modal.Content>
            <Modal.Footer>
                <>
                    <Button
                        fullWidth
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={isValid !== true}>
                        <React.Fragment key=".0">
                            Nästa steg
                            <Icon
                                color={isValid !== true ?"charcoal-500": "white-500"}
                                name="ArrowRightSimple"
                            />
                        </React.Fragment>
                    </Button>
                </>
            </Modal.Footer>
            <ErrorModal show={errorModal} title={errorModal?.title} message={errorModal?.message} onToggle={() => setErrorModal(false)} />
        </>
    );
};